import styled from 'styled-components';

import Loader from '@formstack/phoenix/components/Loader';

const AppLoadingBase = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
`;

const AppLoader = () => (
  <AppLoadingBase>
    <Loader dimension="80px" />
  </AppLoadingBase>
);

export { AppLoader };
